import * as moment from "moment";
import * as DateTimeModule from "react-datetime";
import { useEffect, useRef, useState } from "react";
import { Button, Overlay } from "react-bootstrap";
import { ICellRendererParams } from "ag-grid-community";
import { ILateBloodDraw } from "@nkr/models/index";
import { DatePickerPopover } from "./styles";

const DateTime = (DateTimeModule as any).default;

export interface IBloodDrawDateCellContext {
    isEditable: boolean;
    onBloodDrawDateSelected: (serologyTrackingId: number, bloodDrawDate: string) => void;
}

const BloodDrawDateCell = (params: ICellRendererParams) => {
    const row: ILateBloodDraw = params.data;
    const context: IBloodDrawDateCellContext = params.context;
    const surgeryDate = moment(row.kidneyPickupDate, "MM/DD/YYYY");
    const bloodDrawDate = moment(row.bloodDrawDate, "MM/DD/YYYY");
    const [show, setShow] = useState(false);
    const trigger = useRef(null);

    useEffect(() => {
        if (show == false) {
            return;
        }

        const close = () => setShow(false);
        params.api.addEventListener("bodyScroll", close);

        return () => params.api.removeEventListener("bodyScroll", close);
    }, [show]);

    if (context.isEditable == false || surgeryDate.isAfter(moment(), "day") == false) {
        return <>{row.bloodDrawDate}</>;
    }

    const earliest = surgeryDate.clone().subtract(7, "day");
    const latest = surgeryDate.clone().subtract(1, "day");

    const isValidDate = (currentDate: moment.Moment): boolean => {
        return currentDate.isBetween(earliest, latest, "day", "[]");
    };

    const handleChange = (value: moment.Moment) => {
        setShow(false);

        if (value.isSame(bloodDrawDate, "day")) {
            return;
        }

        context.onBloodDrawDateSelected(row.serologyTrackingId, value.format("YYYY-MM-DD"));
    };

    return (
        <div ref={trigger}>
            {row.bloodDrawDate}
            <Button
                bsStyle="link"
                bsSize="xs"
                onClick={(e: any) => {
                    e.stopPropagation();
                    setShow(!show);
                }}
            >
                <span className="glyphicon glyphicon-calendar"></span>
            </Button>
            <Overlay
                show={show}
                target={() => trigger.current}
                onHide={() => setShow(false)}
                placement="bottom"
                rootClose
            >
                <DatePickerPopover id={`blood-draw-date-${row.serologyTrackingId}`}>
                    <DateTime
                        input={false}
                        timeFormat={false}
                        dateFormat="MM/DD/YYYY"
                        value={bloodDrawDate}
                        initialViewDate={latest}
                        isValidDate={isValidDate}
                        onChange={handleChange}
                    />
                </DatePickerPopover>
            </Overlay>
        </div>
    );
};

export default BloodDrawDateCell;
